import i from "./isArrayLike.js";
import t from "./isObjectLike.js";
function f(r) {
  return t(r) && i(r);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isArrayLikeObject.js
// module id = 1563
// module chunks = 67